module.exports = __webpack_public_path__ + "static/img/ydh2_quit_confirm.b85d4131.png";